import { Component, Input, OnInit } from '@angular/core';
import { HelpText, HelpTextFormBuilder } from '../../model/HelpText';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FormUtilsService } from '../../services/form-utils.service';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { HelpTextService } from '../../services/help-text.service';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';

@Component({
  selector: 'app-edit-help-text-dialog',
  templateUrl: './edit-help-text-dialog.component.html',
  styleUrls: ['./edit-help-text-dialog.component.scss']
})
export class EditHelpTextDialogComponent extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef, private fb: UntypedFormBuilder,
    private helpTextService: HelpTextService,
    private formUtilsService: FormUtilsService, 
    private uiNotification: UiNotificationService) {
    super(dialog);
    }

  helpTextForm: UntypedFormGroup;
  @Input() code: string;
  
  helpText: HelpText;
  error: string;

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.helpTextService.getHelpText(this.code).subscribe({
      next: (r) => {
        this.helpText = r;
        if(!r){
          this.helpText = HelpTextFormBuilder.initHelpText(this.code);
        }
        this.helpTextForm = HelpTextFormBuilder.getForm(this.fb, this.helpText);
      }
    });
  }
  

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm() {
   
    if(!this.formUtilsService.markFormGroupTouched(this.helpTextForm)){
      this.uiNotification.showValidationError();
      return;
    }

    Object.assign(this.helpText, this.helpTextForm.value);

      this.helpTextService.storeHelpText(this.helpText).subscribe(
        () => { 
          this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
          this.dialog.close({ text: 'OK' });
         });
      }
  }
